import Image from 'next/image';

import { RewardTokens } from './RewardTokens';
import { formatDate, TransformedDapp } from '@/utils';
import { Divider } from '../Divider';
import { MerklDappCampaignsEntity } from '@/hooks/other/useMerklDappCampaigns';
import { Tooltip } from '../Tooltip';

export const AvailableRewards = ({
  tokens,
  dappCampaignsInfo,
}: {
  tokens: TransformedDapp['rewardTokens'];
  dappCampaignsInfo: MerklDappCampaignsEntity | undefined;
}) => {
  return (
    <>
      <div className="w-full flex items-center py-3 px-4 gap-2 bg-neutral-900 rounded-lg ">
        <p className="font-mono font-semibold text-sm text-neutral-100 uppercase">Total Rewards Available</p>
        <Tooltip trigger={<Image src="/assets/icons/info.svg" width={16} height={16} alt="info icon" />}>
          This is the total amount of all the reward campaigns that have been published on Merkl or Fuul for the
          entirety of their duration. Some projects run their campaign elsewhere; check with the project for details.
        </Tooltip>
      </div>
      <div className="w-full flex gap-4">
        <RewardTokens tokens={tokens} />
      </div>
      <div className="w-full flex flex-col">
        <div className="w-full grid grid-cols-3 px-4 py-2">
          <p className="grid-cols-1 font-mono text-xs text-grey-600 uppercase">Rewards Tokens</p>
          <div className="flex">
            {tokens.map((token) => (
              <p key={token.name} className="group font-sans font-medium text-xs text-grey-500 uppercase">
                <span>{token.name}</span>
                <span className="group-last:hidden">, </span>
              </p>
            ))}
          </div>
        </div>
        <Divider className="my-4" />
        <div className="w-full grid grid-cols-3 px-4 py-2">
          <p className="grid-cols-1 font-mono text-xs text-grey-600 uppercase">Reward Period</p>
          <p className="font-sans font-medium text-xs text-grey-500 uppercase">
            {dappCampaignsInfo?.reward_period_from && formatDate(dappCampaignsInfo?.reward_period_from, 'dd MMM yyyy')}{' '}
            - {dappCampaignsInfo?.reward_period_to && formatDate(dappCampaignsInfo?.reward_period_to, 'dd MMM yyyy')}
          </p>
        </div>
      </div>
    </>
  );
};
